export default function () {
    return {
        data: []
    }
}